import { AxiosError, AxiosInstance } from "axios";
import { store } from "../app/store";
import { resetToken } from "../slices/token";
import { resetUser } from "../slices/user";
import { setSessionExpired } from "../slices/session";

const AUTH_ENDPOINTS = ["/api/auth/local"];

let isHandlingUnauthorized = false;

export const setupAxiosInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error: AxiosError) => {
      const status = error.response?.status;
      const requestUrl = error.config?.url ?? "";
      const hadUserToken = Boolean(localStorage.getItem("token"));
      const isAuthEndpoint = AUTH_ENDPOINTS.some((endpoint) =>
        requestUrl.includes(endpoint),
      );

      if (
        status === 401 &&
        hadUserToken &&
        !isAuthEndpoint &&
        !isHandlingUnauthorized
      ) {
        isHandlingUnauthorized = true;

        store.dispatch(resetToken());
        store.dispatch(resetUser());
        store.dispatch(setSessionExpired());

        setTimeout(() => {
          isHandlingUnauthorized = false;
        }, 1000);
      }

      return Promise.reject(error);
    },
  );
};
